import { ReactNode } from "react";
import { create } from "zustand";

type IModalProps = {
  title?: string;
  isOpen: boolean;
  inner: ReactNode | null;
  styles?: string;
  chkBnt?: boolean;
  cnclBtn?: boolean;
  chkBtnTex?: string;
  cnclBtnTex?: string;
  keep?: boolean;
  onSetConfirm?: () => void; // 확인 handle
  onSetClose?: () => void;
};

interface SetModal {
  title: string;
  isOpen: boolean;
  inner: ReactNode | null;
  styles?: string;
  chkBnt: boolean;
  cnclBtn: boolean;
  chkBtnTex?: string;
  cnclBtnTex?: string;
  keep?: boolean;
  setTitle: (title: string) => void;
  handleModal: (isOpen: boolean) => void;
  onSetConfirm: () => void; // 확인 handle
  onSetClose: () => void;
  onSetStyles: (style: string) => void;
  onSetModal: ({
    title,
    isOpen,
    inner,
    chkBnt,
    cnclBtn,
    styles,
    chkBtnTex,
    cnclBtnTex,
    keep,
  }: IModalProps) => void;
}

const useModalStore = create<SetModal>((set) => ({
  title: "",
  isOpen: false,
  inner: null,
  chkBnt: true,
  cnclBtn: false,
  styles: "",
  chkBtnTex: "btn_confirm",
  cnclBtnTex: "btn_cancel",

  setTitle: (title) => {
    set({ title: title });
  },

  handleModal: (isOpen) => {
    set({ isOpen: isOpen });
  },

  onSetConfirm: () => {},
  onSetClose: () => {},
  onSetStyles: (style: string) => {
    set({ styles: style });
  },

  onSetModal: ({
    title = "",
    isOpen,
    inner,
    styles = "",
    chkBnt = false,
    cnclBtn = false,
    chkBtnTex = "btn_confirm",
    cnclBtnTex = "btn_cancel",
    keep = false,
    onSetConfirm,
    onSetClose,
  }: IModalProps) => {
    set({
      title,
      isOpen,
      inner,
      styles,
      cnclBtn,
      chkBnt,
      chkBtnTex,
      cnclBtnTex,
      keep,
      onSetConfirm,
      onSetClose,
    });
  },
}));

export default useModalStore;
